import { Locale } from 'modules/i18n';

export const aapiInfoTabsTranslation = {
  [Locale.en]: {
    about: 'About AAPI',
    networks: 'Networks supported',
    pricing: 'Pricing',
  },
};
